// extracted by mini-css-extract-plugin
export default {"title":"items-preview_title__aKgBJ","subtitle":"items-preview_subtitle__sIL9N","imagesContainer":"items-preview_imagesContainer__cc9UI","image":"items-preview_image__fUnGU"};